// Multivariate Dependencies
import React from 'react';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var FontIcon = function (_a) {
    var alt = _a.alt, icon = _a.icon;
    var iconArray = Array.isArray(icon) ? icon : [icon];
    return (React.createElement("div", { className: 'iconWraper', title: alt },
        React.createElement("div", { className: 'iconContainer' }, iconArray.map(function (iconClass) { return (React.createElement("i", { key: iconClass, className: "icon ".concat(iconClass) })); })),
        React.createElement("div", { className: 'clear' })));
};
FontIcon.defaultProps = {
    alt: '',
};
//# sourceMappingURL=FontIcon.js.map